import { BaseConfig } from '../ServiceConfig';

export interface ReferrerConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.ReferrerServiceConfigData';
  url: string;
  platformId: number;
  invitationLink: string;
}

export const ReferrerConfigurationFields: (keyof ReferrerConfiguration)[] = [
  'url',
  'platformId',
  'invitationLink',
];

export const BlankReferrerConfiguration: ReferrerConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.ReferrerServiceConfigData',
} as ReferrerConfiguration;
